import React, { Component } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

export default class Snackbar1 extends Component {
  render() {
    const { open, message, status = "info", close_snack_bar } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={3000}
        onClose={close_snack_bar}
      >
        <Alert
          severity={status} // accepts "success", "error", "warning", "info"
          variant="filled"
          sx={{
            borderRadius: "12px",
            boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
            fontSize: "0.95rem",
            display: "flex",
            alignItems: "center",
          }}
          action={
            <IconButton
              aria-label="close"
              size="small"
              sx={{ color: "#fff" }}
              onClick={close_snack_bar}
            >
              <CancelRoundedIcon fontSize="small" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      </Snackbar>
    );
  }
}
